import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

import { InfoMessage } from '../../common/components';
import PublicTaskContent from './components/PublicTaskContent';

export const styles = () => ({
    root: {
    },
});

const Task = ({ classes, task, hasLoaded }) => {
    if (!task) {
        return hasLoaded ? (<InfoMessage messageKey="noContent" />) : null;
    }

    return (
        <div className={classes.root}>
            <PublicTaskContent
                showTitle
                task={task}
            />
        </div>
    );
};

Task.propTypes = {
    classes: PropTypes.object.isRequired,
    hasLoaded: PropTypes.bool.isRequired,
    task: PropTypes.object,
};

Task.defaultProps = {
    task: null,
};

const mapStateToProps = (state, ownProps) => {
    const itemId = ownProps?.match?.params?.taskId;
    const task = itemId && state.program.content && state.program.content[state.pageSettings.appConfig?.contentProgramId]?.modules
        ?.reduce((prev, curr) => prev || curr.tasks?.find(d => d.id === itemId)
    , null);

    return {
        clientConfig: state.auth.clientConfig,
        hasLoaded: Boolean(state.program.content && state.program.content[state.pageSettings.appConfig?.contentProgramId]),
        task,
    };
};

export default connect(mapStateToProps)(withStyles(styles)(Task));
